// @flow strict

// "Peter Huang" > "peter-huang"
export const slugifyString = (str: string) => {
  const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;'
  const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  if (!str) {
    console.warn('No string provided to slugify')
    return ''
  }
  return str
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

// Takes a number and returns a formatted string with the correct abbreviation
// 1430000 -> 1.43M
export const formatNumberOfAccounts = (originalValue: string) => {
  const value = Math.abs(Number(originalValue))
  switch (true) {
    case value >= 1.0e9: // Billion
      return (value / 1.0e9).toFixed(2) + 'B'
    case value >= 1.0e6: // Million
      return (value / 1.0e6).toFixed(2) + 'M'
    case value >= 1.0e3: // Thousand
      return (value / 1.0e3).toFixed(2) + 'K'
    default:
      return value
  }
}
